import React, { Children } from 'react';
import { motion } from 'framer-motion';
const results = [{
  image: 'https://cdn.magicpatterns.com/uploads/cCUE9szEu4PVxx9QZjrJA3/foto_cliente_1.jpg',
  label: 'Verduras asadas'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5zJdLHRpd63edf2WFp6jTn/foto_cliente_2.jpg',
  label: 'Empanadas'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/wfBYEBY5TytVCGRXYzkJfw/foto_cliente_3.jpg',
  label: 'Pollo crocante'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/fx7Hnge6MNWspeSB3qsjLr/foto_cliente_4.jpg',
  label: 'Milanesa con papas'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cCv5FsUbnRjxVhKWJeXAHo/foto_cliente_5.jpg',
  label: 'Hamburguesas'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function CustomerResultsSection() {
  return <section className="w-full py-12 md:py-20 px-6 bg-surface" data-id="element-119">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="mb-10" data-id="element-121">
          <div className="inline-flex items-center gap-2 bg-white/80 border border-charcoal/10 rounded-full px-4 py-1.5 mb-6 shadow-sm" data-id="element-122">
            <span className="text-sm font-medium text-charcoal/80" data-id="element-123">
              📸 Fotos reales — sin filtros ni edición
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-charcoal" data-id="element-124">
            Resultados reales de nuestros clientes
          </h2>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-125">
            Estas fotos las mandaron personas que compraron el recetario y
            cocinaron en su casa.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-126">
          {results.map((result, index) => <motion.div key={index} variants={itemVariants} className={`relative rounded-2xl overflow-hidden shadow-soft aspect-square group ${index >= 3 ? 'md:col-span-1 md:w-[80%] md:mx-auto' : ''} ${index === 3 ? 'md:col-start-1 md:justify-self-end' : ''} ${index === 4 ? 'md:col-start-3 md:justify-self-start' : ''}`} style={index >= 3 ? {
          gridColumn: 'auto'
        } // Reset for mobile, handled by flex/grid classes below
        : {}} data-id="element-127">
              <img src={result.image} alt={result.label} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-128" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80" data-id="element-129" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-left" data-id="element-130">
                <span className="text-white font-medium text-sm md:text-base drop-shadow-md" data-id="element-131">
                  {result.label}
                </span>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Custom layout for the bottom 2 items on desktop to center them in a 3-col grid */}
        <style data-id="element-132">{`
          @media (min-width: 768px) {
            .grid > div:nth-child(4) {
              grid-column: 1 / 3;
              justify-self: end;
              width: calc(150% - 12px);
              max-width: 100%;
            }
            .grid > div:nth-child(5) {
              grid-column: 2 / 4;
              justify-self: start;
              width: calc(150% - 12px);
              max-width: 100%;
            }
            /* A better approach for the 3-2 layout */
            .grid {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
            }
            .grid > div {
              width: calc(33.333% - 16px);
              flex-grow: 0;
            }
          }
          @media (max-width: 767px) {
             .grid {
              display: grid;
             }
             .grid > div:nth-child(5) {
               grid-column: 1 / -1;
               aspect-ratio: 2 / 1;
             }
          }
        `}</style>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} data-id="element-133">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-134">
            Quiero lograr estos resultados →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}